import React from 'react';
import { LogOut, Activity } from 'lucide-react';
import Logo from '../ui/Logo';
import { TABS } from '../../constants/uiConstants';
import { isDemoMode, getSwitchUrl } from '../../utils/demoUtils';

const Navbar = ({
  activeTab,
  setActiveTab,
  user,
  userProfile,
  isAuthenticated,
  isAuthLoading,
  logout,
  loginWithRedirect,
  setShowEditProfileModal,
}) => {
  const isDemo = isDemoMode();
  const switchUrl = getSwitchUrl();

  const navTabs = [TABS.LEADERBOARD, TABS.BREAD, TABS.MATCHES, TABS.ANALYTICS];

  return (
    <nav
      className={`border-b border-zinc-100 bg-white sticky ${
        isDemo ? 'top-8' : 'top-0'
      } z-20`}
    >
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <button
          onClick={() => setActiveTab(TABS.LEADERBOARD)}
          className="flex items-center gap-3 select-none"
        >
          <Logo className="h-10 w-auto" />
        </button>

        <div className="hidden md:flex items-center gap-8">
          {navTabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`text-sm font-medium transition-colors relative py-5 ${
                activeTab === tab
                  ? 'text-zinc-900'
                  : 'text-zinc-500 hover:text-zinc-700'
              }`}
            >
              {tab === TABS.BREAD
                ? 'The Bread Tracker'
                : tab.charAt(0).toUpperCase() + tab.slice(1)}
              {activeTab === tab && (
                <span className="absolute bottom-0 left-0 w-full h-[2px] bg-zinc-900"></span>
              )}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-4">
          {isAuthLoading ? (
            <div className="h-8 w-24 bg-zinc-100 rounded animate-pulse"></div>
          ) : isAuthenticated ? (
            <div className="flex items-center gap-3">
              {(userProfile || user) && (
                <button
                  onClick={() => setShowEditProfileModal(true)}
                  className="text-right hidden sm:block leading-tight group relative p-[1px] rounded-full overflow-hidden"
                  title={`${userProfile?.name || user?.name || user?.email?.split('@')[0] || 'User'}${(userProfile?.email || user?.email) ? ` (${userProfile?.email || user?.email})` : ''}`}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-shimmer bg-[length:200%_100%]" />
                  <div className="relative px-3 py-1.5 bg-white rounded-full transition-colors">
                    <div className="text-xs font-bold text-zinc-900 group-hover:text-indigo-600 transition-colors">
                      {userProfile?.name ||
                        user?.name ||
                        user?.email?.split('@')[0] ||
                        'User'}
                    </div>
                  </div>
                </button>
              )}
              {isDemo ? (
                <a
                  href={switchUrl}
                  className="text-xs text-zinc-500 hover:text-zinc-900 transition-colors"
                  title="Go to Live App"
                >
                  <LogOut className="w-4 h-4" />
                </a>
              ) : (
                <button
                  onClick={() =>
                    logout({
                      logoutParams: { returnTo: window.location.origin },
                    })
                  }
                  className="text-xs text-zinc-500 hover:text-zinc-900 transition-colors"
                  title="Log Out"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-3">
              {!isDemo && (
                <a
                  href={switchUrl}
                  className="relative group p-[1px] rounded-full inline-block overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-shimmer bg-[length:200%_100%]" />
                  <div className="relative px-4 py-1.5 bg-white rounded-full text-xs font-bold text-zinc-900 group-hover:text-indigo-600 transition-colors z-10 flex items-center gap-1">
                    <Activity className="w-3 h-3" />
                    Try Demo Mode
                  </div>
                </a>
              )}
              <button
                onClick={() => loginWithRedirect()}
                className="text-xs font-bold text-zinc-900 hover:text-indigo-600 transition-colors"
              >
                Log In
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
